export default __webpack_public_path__ + "static/media/showcase-choose-todo-something-hard.8b28417b.jpg";